import styled from "styled-components";

export const WhatsappLink = styled.a`
    position: fixed;
	width: 60px;
	height: 60px;
	bottom: 30px;
	right: 30px;
	background-color: #25d366;
	color: #FFF;
	border-radius: 50px;
	text-align: center;
    font-size: 30px;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
    text-decoration: none;
    border: none;
    outline: none;
    
    &:hover {
        transform: scale(1.1);
        box-shadow: 0 6px 20px rgba(37, 211, 102, 0.4);
        text-decoration: none;
    }
    
    &:focus {
        outline: none;
        text-decoration: none;
    }
    
    &:visited {
        text-decoration: none;
    }
    
    @media screen and (max-width: 768px) {
        width: 55px;
        height: 55px;
        bottom: 160px;
        right: 20px;
        font-size: 28px;
    }
    
    @media screen and (max-width: 480px) {
        width: 50px;
        height: 50px;
        bottom: 15px;
        right: 15px;
        font-size: 26px;
    }
`

export const WhatsappIcon = styled.i`
    margin-top: 0;
    text-decoration: none;
    border: none;
    outline: none;
    
    &:before {
        text-decoration: none;
    }
`